module.exports = __webpack_public_path__ + "static/media/ls-5.fd7b53fc.jpg";